// ============================================================================
// Hook — sélecteur de contexte corporate A3 (GET/POST /api/context)
// ============================================================================
// ACCESS-CONTROL-STANDARD §5. Le SPA lit l'état du sélecteur (visibilité +
// compagnies commutables + contexte courant) et déclenche la bascule serveur.
// Miroir CLIENT : la visibilité `isCorporateAdmin` vient du SERVEUR (jamais
// re-dérivée du front) ; l'autorité reste les gardes serveur. Une bascule
// invalide TOUT le cache (les données se re-chargent scopées à la nouvelle
// compagnie via RLS ; sans porte 2 -> EmptyState, comportement normal).

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@gs/api-client';

export interface CorporateContextCompany {
  companyId: string;
  companyName: string;
  companyCode: string;
}

export interface CorporateContextState {
  /** Résolu SERVEUR (grant UCA/ADM, pas le flag home). false => sélecteur masqué. */
  isCorporateAdmin: boolean;
  companies: CorporateContextCompany[];
  currentCompanyId: string;
  homeCompanyId: string;
  switched: boolean;
}

/** État du sélecteur de contexte (GET /api/context). */
export function useCorporateContext(enabled: boolean) {
  return useQuery({
    queryKey: ['gest', 'context'],
    queryFn: () => api.get<CorporateContextState>('/api/context'),
    enabled,
    // État d'accès stable, pas transitoire : pas de retry (aligné createGsQueryClient).
    retry: false,
  });
}

/** Bascule de contexte (POST /api/context) + invalidation globale du cache. */
export function useSetContext() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (companyId: string) =>
      api.post<{ companyId: string; switched: boolean }>('/api/context', { companyId }),
    onSuccess: () => {
      // La nouvelle compagnie re-scope toutes les lectures (RLS) -> refetch complet.
      void qc.invalidateQueries();
    },
  });
}
